
	import { defineComponent } from 'vue';

	import FiscalYearReportByParticipant from '@/ChildrenComponents/Reports/FiscalYearReportByParticipant.vue';

	import { IAncillaryServiceReport, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';

    import { ReportService } from '@/Services/Report/report-service';

	export default defineComponent({
		name: 'ancillary-service-report',
		components: { FiscalYearReportByParticipant },
		data () {
			return {
				reportData: [] as IAncillaryServiceReport[],
				isSearching: false,
			}
		},
		methods: {
			getReportData(searchDto: IFiscalYearReportSearch) {
				this.isSearching = true;
				ReportService.getAncillaryServiceReportData(searchDto).then(response => this.reportData = response).finally(() => this.isSearching = false);
			}
		},
	});
